import { showSimpleError } from './toast'
import { useUIStore } from '@/state/ui.store'

export const AI_CREDITS_ERROR_MESSAGE = 'Not enough AI credits. Please add credits to continue.'

export function showAiCreditsRequired(errorOrMessage) {
  const code = typeof errorOrMessage === 'object' ? errorOrMessage?.code : ''
  const message = typeof errorOrMessage === 'string' ? errorOrMessage : errorOrMessage?.message
  const isCreditError = code === 'AI_CREDITS_EXHAUSTED'
    || code === 'FORM_AI_TEMPORARILY_UNAVAILABLE'
    || /ai credits|credit balance|insufficient credits/i.test(message || '')

  if (!isCreditError) return false

  useUIStore.getState().setShowPricingModal(true, 'AI_CREDITS')
  showSimpleError(AI_CREDITS_ERROR_MESSAGE)
  return true
}